'use client';

import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let threshold = 300;
    let frame = 0;
    const toggleVisibility = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        setIsVisible(window.scrollY > threshold);
        frame = 0;
      });
    };
    const measure = () => {
      threshold = Math.max(0, (document.documentElement.scrollHeight - window.innerHeight) * 0.1);
      toggleVisibility();
    };
    const observer = new ResizeObserver(measure);
    observer.observe(document.body);
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    measure();
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', measure);
      cancelAnimationFrame(frame);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="fixed bottom-8 right-8 z-50 bg-[#6366F1] text-white p-4 rounded-full shadow-lg hover:bg-[#5558E3] transition-[color,background-color,border-color,opacity,transform] duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#6366F1] focus:ring-offset-2"
    >
      <ArrowUp className="w-5 h-5" aria-hidden="true" />
    </button>
  );
}

